import { render, staticRenderFns } from "./ReplyOtherUserOpinionTab.vue?vue&type=template&id=51f8d198&scoped=true&lang=pug"
import script from "./ReplyOtherUserOpinionTab.vue?vue&type=script&lang=ts"
export * from "./ReplyOtherUserOpinionTab.vue?vue&type=script&lang=ts"
import style0 from "./ReplyOtherUserOpinionTab.vue?vue&type=style&index=0&id=51f8d198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f8d198",
  null
  
)

export default component.exports